var _defs, _path, _path2, _path3, _path4, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlatbedOpenTrailer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1041 605.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416.4,513.2h-69.5c-4.8,0-7.7-1.9-11-4.8-10.1-7.7-13.4-16.8-12.5-29.7,1-11.5,0-24,0-35.5s1-4.8,4.8-4.8h143.8c3.4,0,5.3,1.4,8.1,3.4,10.5,8.1,15.3,18.2,13.9,32.6-1,10.5,0,22.5,0,33.1s-1.4,6.2-6.2,6.2h-71.4v-.5ZM410.6,491.6h57c4.8,0,5.8-1.4,5.3-5.8v-18.7c0-5.3-2.9-8.1-8.1-8.1h-115.5c-3.4,0-4.3,1-4.3,4.3v18.7c0,6.2,2.9,9.1,9.1,9.1h56.6v.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.1,427.9c29.7,0,53.7,24,53.2,53.2,0,29.2-24,53.2-53.2,53.2s-53.2-24-53.2-53.2,24-52.7,53.2-53.2ZM143.1,512.2c17.7,0,32.1-14.4,32.1-32.1s-14.4-31.2-31.2-32.1c-17.7,0-32.1,13.9-32.1,31.2s13.9,32.6,31.2,32.6h0v.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.1,427.9c29.2,0,53.2,23.5,53.2,52.3s-23,54.2-52.7,54.2-53.2-23.5-53.2-53.2,23.5-53.2,52.7-53.2ZM292.2,481.1c0-17.7-13.9-31.2-31.2-32.1-17.7,0-32.1,13.9-32.1,32.1s13.9,32.1,32.1,32.1,31.2-13.9,31.2-31.2h0s0-1,0-1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.5,506.8c-13.3,0-20.6-3.4-26.2-11.2-1.3-1.7-2.1-3-2.1-5.6v-31.3c0-3,.9-3.9,3.9-3.9h31.3c4.7,0,7.7-1.3,7.7-6.4s.9-2.1,2.6-2.1h5.6c3,0,6.9-1.7,9,1.3s-.9,11.2-3.4,14.6c-6.4,8.6-14.6,11.6-24.9,10.3h-12c-4.3,0-3,.9-3,3v6.9c0,5.6,1.7,7.3,7.3,7.3h31.8c3,0,3.9.9,3.9,3.9,0,9-4.3,13.7-13.3,13.7h-18.5.4v-.4Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M598.8,513.2h69.5c4.8,0,7.7-1.9,11-4.8,10.1-7.7,13.4-16.8,12.5-29.7-1-11.5,0-24,0-35.5s-1-4.8-4.8-4.8h-143.8c-3.4,0-5.3,1.4-8.1,3.4-10.5,8.1-15.3,18.2-13.9,32.6,1,10.5,0,22.5,0,33.1s1.4,6.2,6.2,6.2h71.4v-.5ZM604.6,491.6h-57c-4.8,0-5.8-1.4-5.3-5.8v-18.7c0-5.3,2.9-8.1,8.1-8.1h115.5c3.4,0,4.3,1,4.3,4.3v18.7c0,6.2-2.9,9.1-9.1,9.1h-56.6v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M872.1,427.9c-29.7,0-53.7,24-53.2,53.2,0,29.2,24,53.2,53.2,53.2s53.2-24,53.2-53.2-24-52.7-53.2-53.2ZM872.1,512.2c-17.7,0-32.1-14.4-32.1-32.1s14.4-31.2,31.2-32.1c17.7,0,32.1,13.9,32.1,31.2s-13.9,32.6-31.2,32.6h0v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M755.1,427.9c-29.2,0-53.2,23.5-53.2,52.3s23,54.2,52.7,54.2,53.2-23.5,53.2-53.2-23.5-53.2-52.7-53.2ZM723,481.1c0-17.7,13.9-31.2,31.2-32.1,17.7,0,32.1,13.9,32.1,32.1s-13.9,32.1-32.1,32.1-31.2-13.9-31.2-31.2h0s0-1,0-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.5,
    y: 392.9,
    width: 1029.9,
    height: 23.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 975.9,
    y: 407.3,
    width: 24.7,
    height: 105.4
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.6,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.1,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.6,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 206.5,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 256,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.5,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 355,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 404.4,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 453.9,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 503.4,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 552.9,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 602.4,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 651.8,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 701.3,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 750.8,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 800.3,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 849.8,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 899.2,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 948.7,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 998.2,
    y: 365.3,
    width: 35.3,
    height: 20.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatbedOpenTrailer);
export default __webpack_public_path__ + "static/media/flatbed-open-trailer.b5e67e5b0185075fa31eaf014c213c7a.svg";
export { ForwardRef as ReactComponent };